import React, { useState, useEffect } from "react";
import { Game } from "../../Game/Game.jsx";

export default function CasinoSuperbombaResults (props) {
    const [resultsNumber, setResultsNumber] = useState(25);

    const [tabs, setTabs] = useState(['Popis igara', 'Osvojene nagrade']);
    const [selectedTab, setSelectedTab] = useState('Popis igara');

    function renderResults() {
        return (
            <span>
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>Natjecatelj</th>
                            <th>Nagrada</th>
                            <th>Dan i sat</th>
                            <th>Osvojeno</th>
                        </tr>
                    </thead>
                    <tbody>
                    {props.results.slice(0, resultsNumber).map((player) => renderPlayerRow(player))}
                    </tbody>
                </table> 
                {props.results.length > 25 &&  props.results.length > resultsNumber && <div className="text-center">
                    <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => setResultsNumber(resultsNumber+25)}>
                        <span className="icon ico-chevron-down"></span> 
                        &nbsp; <span>Prikaži više</span>
                        </button>
                </div>} 
            </span>
        )
    }

    function renderPlayerRow(player) {
        return (
            <tr key={player.danISat}>
                <td>
                    {player.ime}
                </td>
                <td>{player.nagrada}</td>
                <td>{casino.utils.dateToShortDateString(new Date(player.danISat))} {casino.utils.dateToTimeString(new Date(player.danISat))} h</td>
                <td><b>{casino.utils.numberWithCurrencyFromated(player.osvojeno, props.info.valuta)}</b></td>
            </tr>
        )
    }

    function renderTabs() {
        setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);     

        return <div id="tabs">
                <div className="segment v2">
                {tabs && tabs.map((tab) =>
                    <button key={tab} onClick={() => goToTab(tab)} className={'segment--btn' + (selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
                </div>
                {selectedTab == 'Osvojene nagrade'  && renderResults()}
                {selectedTab == 'Popis igara' && renderPopisIgara()}
        </div>
    }

    function dohvatiIgre() {
        var utrkaIgraSifreArray = props.info.igreSifre.split(',');

        return props.games.filter(function (igra) {
            if (utrkaIgraSifreArray.includes(igra.s))
                return igra;
        });
    }

    function renderIgra(igra, i) {
        return <Game
            brands={props.brands}
            categories={props.gameCategories}
            routePrefix={"/promotions/casino-superbomba/" + props?.kampanja}
            key={igra.s} igra={igra}
            showJackpot={true}
            goLazyImage={true}
            fromNative={casino.config.fromNativeApp}
            fromNativeGameName={true}
            // GamePosition podaci, HizmanB
            PageName={`Kampanje-{${props.kampanja}}`}
            GamePosition={i + 1}
            PositionType="lista_igara"
            IsIcon={false}
        />;
    }

    function goToTab(tab) {
        if (tab === "Popis igara") {
            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        }
        setSelectedTab(tab);
    }

    function renderPopisIgara() {
        return <div>
               <div id="game-container" className="maximum margin-center">      
                       <br></br>
                       <div className={"clearfix white games-container"} style={(props.games) ? { padding: '0px' } : {}} >
                           {!props.games && <div>Dohvaćanje igara...</div>}
                           {props.games && dohvatiIgre().map(renderIgra)}
                       </div>
               </div>
           </div>
    }

    return (
        <>
            {props.info?.igreSifre && <div className="casino-superbomba-section" id="games">
                {renderTabs()}
            </div>
            }

            {props.results?.length > 0 && !props.info?.igreSifre && <div className="casino-superbomba-section">          
                <h2>Zadnje osvojeno</h2>    
                <p className="total-players">Zadnje osvojene nagrade</p>
                <div className="divider order"></div>
                {renderResults()}
            </div>}
        </>
    )
 }
